var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentTranslationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 368,
    viewBox: "0 0 255 368",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    clipPath: "url(#clip0_267_2380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.895 128.285C327.381 114.115 321.241 100.796 308.25 94.615C291.963 86.866 263.549 75.6943 216.065 62.9711C168.581 50.2479 138.388 45.7157 120.408 44.2829C106.067 43.1399 94.09 51.6047 89.1584 65.1196C83.3628 81.0041 74.6488 107.78 62.9718 151.359C51.2949 194.938 45.4533 222.484 42.5302 239.139C40.0436 253.308 46.1837 266.628 59.1747 272.809C75.4622 280.558 103.876 291.729 151.36 304.453C198.844 317.176 229.037 321.708 247.017 323.141C261.358 324.283 273.335 315.819 278.267 302.304C284.063 286.42 292.776 259.643 304.453 216.064C316.13 172.485 321.972 144.939 324.895 128.285Z",
    fill: "#DCE2F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.961 75.2731C245.999 71.3985 232.125 67.2744 216.071 62.9728C200.018 58.6712 185.941 55.3061 173.643 52.6802L165.243 104.04C164.508 108.53 168.666 112.276 173.056 111.079L183.529 108.222C185.992 107.55 188.617 108.444 190.157 110.479L196.852 119.323C198.628 121.669 201.8 122.458 204.468 121.219L213.674 116.943C216.018 115.855 218.789 116.32 220.648 118.114L229.288 126.455C232.518 129.575 237.886 128.37 239.475 124.169L257.961 75.2731Z",
    fill: "#6491CF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.55 210.662C165.337 203.993 161.38 197.139 154.711 195.352L106.415 182.411C99.7463 180.625 92.8923 184.582 91.1055 191.25C89.3187 197.919 93.2758 204.773 99.9443 206.56L148.241 219.501C154.909 221.287 161.763 217.33 163.55 210.662Z",
    fill: "#6491CF",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.116 248.068C135.903 241.4 131.946 234.546 125.277 232.759L95.0923 224.671C88.4238 222.884 81.5698 226.841 79.783 233.51C77.9962 240.178 81.9533 247.032 88.6218 248.819L118.807 256.907C125.476 258.694 132.33 254.737 134.116 248.068Z",
    fill: "#6491CF",
    fillOpacity: 0.52
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_2380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white",
    transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 367.424 77.6458)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTranslationIcon);
export default __webpack_public_path__ + "static/media/documentTranslationIcon.a694ba3a26a99384a9562a54022fb409.svg";
export { ForwardRef as ReactComponent };